var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 90,
    viewBox: "0 0 67 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_4202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.800195 13.3L65.3002 13.2V82.3C65.3002 86.1 62.2002 89.1 58.4002 89.1H7.6002C3.8002 89.1 0.700195 86.1 0.700195 82.3L0.800195 13.3Z",
    fill: "white",
    stroke: "#004137",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5001 21.3V8.60001C30.6001 6.80001 29.6001 4.40001 29.6001 2.60001C29.6001 0.900009 27.6001 1.00001 27.6001 1.00001H21.7001H20.8001H14.9001C14.9001 1.00001 12.9001 0.900009 12.9001 2.60001C12.9001 4.40001 11.9001 6.80001 12.0001 8.60001V21.3C12.0001 21.3 11.7001 23.8 14.0001 23.8H20.8001C21.4001 23.8 21.7001 23.8 21.7001 23.8H28.5001C30.8001 23.8 30.5001 21.3 30.5001 21.3Z",
    fill: "#9E8959",
    stroke: "#9E8959",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 4.5V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4004 6.39999V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 6.39999V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5001 21.3V8.60001C54.6001 6.80001 53.6001 4.40001 53.6001 2.60001C53.6001 0.900009 51.6001 1.00001 51.6001 1.00001H45.7001H44.8001H38.9001C38.9001 1.00001 36.9001 0.900009 36.9001 2.60001C36.9001 4.40001 35.9001 6.80001 36.0001 8.60001V21.3C36.0001 21.3 35.7001 23.8 38.0001 23.8H44.8001C45.4001 23.8 45.7001 23.8 45.7001 23.8H52.5001C54.8001 23.8 54.5001 21.3 54.5001 21.3Z",
    fill: "#A971B0",
    stroke: "#A971B0",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2998 4.5V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4004 6.39999V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0996 6.39999V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 24.4V39.4",
    stroke: "#004137",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24.4V39.4",
    stroke: "#004137",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9004 24.4V39.4",
    stroke: "#004137",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9004 24.4V39.4",
    stroke: "#004137",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7002 39.4V29.4H27.0002",
    stroke: "#9E8959",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7002 39.4V29.4H51.0002",
    stroke: "#A971B0",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 33.5V32.7H21V33.5H26.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 34.3V33.9H21V34.3H26.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 35.5V35.1H21V35.5H26.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 37.4V37.1H21V37.4H26.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 39V38.6H21V39H26.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 33.5V32.7H45V33.5H50.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 34.3V33.9H45V34.3H50.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 35.5V35.1H45V35.5H50.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 37.4V37.1H45V37.4H50.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 39V38.6H45V39H50.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2998 39.3H64.6998",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_4202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step-4.ff3fc372e379671049ebf027053fbdcf.svg";
export { ForwardRef as ReactComponent };